export default [
	{ id: 1, name: 'English', code: 'en', icon: '🇺🇸' },
	{ id: 2, name: 'Bulgarian', code: 'bg', icon: '🇧🇬' },
	{ id: 3, name: 'Dutch', code: 'nl', icon: '🇳🇱' },
	{ id: 4, name: 'Russian', code: 'ru', icon: '🇷🇺' },
	{ id: 5, name: 'Armenian', code: 'hy', icon: '🇦🇲' },
	{ id: 6, name: 'French', code: 'fr', icon: '🇫🇷' },
	{ id: 7, name: 'German', code: 'de', icon: '🇩🇪' },
	{ id: 8, name: 'Spanish', code: 'es', icon: '🇪🇸' },
	{ id: 9, name: 'Italian', code: 'it', icon: '🇮🇹' },
	{ id: 10, name: 'Greek', code: 'el', icon: '🇪🇱' },
	{ id: 11, name: 'Portuguese', code: 'pt', icon: '🇵🇹' },
	{ id: 12, name: 'Croatian', code: 'hr', icon: '🇭🇷' },
];